module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.companyName) ? _c('div', {
    staticStyle: {
      "padding-top": "92px"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("您的加入申请已提交，请耐心等待企业管理员审核")]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.gologin
    }
  }, [_vm._v("好的")])]) : _c('div', {
    staticClass: "regbox",
    staticStyle: {
      "padding-top": "125px"
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.goindex
    }
  }, [_vm._v("立即进入 " + _vm._s(_vm.time) + "s")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-line flex flex-center"
  }, [_c('div', {
    staticClass: "iconfont icon-corrent_ico1"
  }), _vm._v(" "), _c('p', [_vm._v("申请提交完成！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-line flex flex-center",
    staticStyle: {
      "margin-bottom": "90px"
    }
  }, [_c('div', {
    staticClass: "iconfont icon-corrent_ico1"
  }), _vm._v(" "), _c('p', [_vm._v("注册完成！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d76a2364","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/regsuc.vue
// module id = 915
// module chunks = 1